import BlockCover from '../plugins/blockCover';

export default function initBlockCover() {
  const $block = document.querySelector('.bg-stretch iframe') as HTMLElement;

  if ($block) {
    new BlockCover($block);
  }
}